import {DeliveryStatus, type Guest, isHostGuest} from '~/ViewInvitation/types/guests';

// biome-ignore lint/suspicious/noExplicitAny: comes from selector
export const normalizeGuestsOfHonor = (goh: any) => {
  // biome-ignore lint/suspicious/noExplicitAny: comes from selector
  return (Array.isArray(goh) ? goh : goh.guests).map((g: any) => {
    if (typeof g === 'string') return {name: g};
    return g;
  });
};

export const deliveryStatusToString = (guest: Guest) => {
  if (isHostGuest(guest) && guest.timesViewed > 0) {
    return 'Viewed';
  }
  if (isHostGuest(guest) && guest.deliveryStatus === DeliveryStatus.DELIVERED) {
    return 'Delivered';
  }
  if (isHostGuest(guest) && guest.deliveryStatus === DeliveryStatus.SENDING) {
    return 'Sending';
  }
  return 'Unknown';
};
